module.exports = __webpack_public_path__ + "assets/img/33_1571_big.bbdb0757.jpg";